import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  FormHelperText,
  CircularProgress,
  InputLabel,
  NativeSelect,
  FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// data
import { installmentTransaction } from "./installmentTransactions-api";
//auth
import auth from "../../../auth/auth-helper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

export default function Transactions() {
  var classes = useStyles();
  var [isLoading, setIsLoading] = useState(false);
  const [month, setMonth] = useState([]);
  const [accountNo, setAccountNo] = useState([]);
  const [amount, setAmount] = useState([]);
  const [detail, setDetail] = useState([]);

  const clickSubmit = () => {
    setIsLoading(true);
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    const transaction = {
      month: setMonth,
      accountNo: accountNo,
      amount: amount,
      detail: detail,
    };

    installmentTransaction(signal, credentials, transaction).then((res) => {
      console.log(transaction);
      if (res.status === 200) {
        setIsLoading(false);
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        //setTransactions(res.response[0]);
      } else {
      }
    });
  };

  return (
    <form className={classes.root} noValidate autoComplete="off" >
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          label="Month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
          <br></br>
        <TextField
          label="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Account No"
          value={accountNo}
          onChange={(e) => setAccountNo(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Detail"
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <div className={classes.creatingButtonContainer}>
          {isLoading ? (
            <CircularProgress size={26} />
          ) : (
            <Button
              disabled={
                month.length === 0 ||
                accountNo.length === 0 ||
                amount.length === 0 ||
                detail.length === 0
              }
              variant="contained"
              color="primary"
              onClick={clickSubmit}
            >
              Continue
            </Button>
          )}
        </div>
      </div>
    </form>
  );
}
